import React from 'react';

import { Table, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import MyCollapse from 'components/Collapse';
import { ShoppingPaymentStatusId, type ShoppingDelivery, type IInstallments } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';

import { TABLE_STATUS_BASE, getStatusColor } from '../statusColors';

const BankSlipInstallment = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const getInstallmentInfo = (installment: IInstallments) => {
    let tooltipMessage = installment.payment_status.name;
    let installmentStatus = installment.payment_status.alias;

    if (
      installment.payment_status.id === ShoppingPaymentStatusId.ABERTA &&
      installment.cycle !== 1 &&
      installment.cycle !== 0
    ) {
      installmentStatus = 'scheduled';
      tooltipMessage = 'Agendada';
    }

    return (
      <Tooltip title={tooltipMessage} placement='top'>
        <div className={`${TABLE_STATUS_BASE} ${getStatusColor(installmentStatus)}`} />
      </Tooltip>
    );
  };

  const columns: ColumnsType<IInstallments> = [
    {
      title: '',
      key: 'status',
      width: 40,
      render: (_, record) => getInstallmentInfo(record)
    },
    {
      title: 'Fatura',
      key: 'invoice_id',
      dataIndex: 'invoice_id'
    },
    {
      title: 'Parcela',
      key: 'cycle',
      align: 'center',
      render: (_, record) =>
        record.cycle && delivery.bankslip_installments.total_cycles
          ? `${record.cycle}/${delivery.bankslip_installments.total_cycles}`
          : ' - '
    },
    {
      title: 'Vencimento',
      key: 'due_date',
      render: (_, record) => dateService.dateToString(new Date(record.due_date), 'dd/MM/yyyy')
    },
    {
      title: 'Valor',
      key: 'value',
      align: 'right',
      render: (_, record) =>
        record.value && record.value > 0
          ? record.value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: delivery.currency_code
            })
          : ' - '
    }
  ];

  return (
    <MyCollapse
      title={
        delivery?.bankslip_installments?.total_cycles
          ? `Boleto Parcelado (${delivery.bankslip_installments.total_cycles} parcelas)`
          : 'Boleto Parcelado'
      }
      arrow
    >
      <Table<IInstallments>
        columns={columns}
        dataSource={delivery?.bankslip_installments?.installments || []}
        rowKey='invoice_id'
        pagination={false}
        size='small'
      />
    </MyCollapse>
  );
};

export default BankSlipInstallment;
